import * as React from 'react';
import { ProductType } from '@grandvisionhq/frk-routing';
import { useIntl } from '@grandvisionhq/state';
import { mapFramesizeFacetToLabelKeys } from '@grandvisionhq/utils';

const getFramesizeDisplayValue = (getLabelFn, frameSize)=>{
    if (!frameSize) return undefined;
    const keys = mapFramesizeFacetToLabelKeys(frameSize);
    return keys ? `${getLabelFn(keys.title)} (${getLabelFn(keys.subtitle)})` : `${frameSize}`;
};
const WishlistItemDescription = ({ item  })=>{
    const { getLabel  } = useIntl();
    const getWishlistItemAttributes = ()=>{
        switch(item.productType){
            case ProductType.Accessories:
                return {
                    [getLabel('products.attributes.accessoryColor')]: item.accessoryColor
                };
            case ProductType.ContactLenses:
                return {
                    [getLabel('products.attributes.lensType')]: item.lensType,
                    [getLabel('products.attributes.contactLenses.boxQuantity')]: item.boxQuantity,
                    [getLabel('products.attributes.replacementFrequency')]: item.replacementFrequency
                };
            case ProductType.Frames:
                {
                    const frameSize = getFramesizeDisplayValue(getLabel, item.frameSize);
                    return {
                        [getLabel('products.attributes.frameColor')]: item.frameColor,
                        [getLabel('products.attributes.frameSize')]: frameSize
                    };
                }
            case ProductType.ReadyReaders:
                {
                    const frameSize = getFramesizeDisplayValue(getLabel, item.frameSize);
                    return {
                        [getLabel('products.attributes.frameColor')]: item.frameColor,
                        [getLabel('products.attributes.frameSize')]: frameSize
                    };
                }
            case ProductType.Solutions:
                // PackageOptions attribute is not yet available for ShoppinglistLineItem, will be added in MACC-17870
                return {};
            case ProductType.Sunglasses:
                {
                    const frameSize = getFramesizeDisplayValue(getLabel, item.frameSize);
                    return {
                        [getLabel('products.attributes.lensColor')]: item.lensColor,
                        [getLabel('products.attributes.frameColor')]: item.frameColor,
                        [getLabel('products.attributes.frameSize')]: frameSize
                    };
                }
        }
    };
    const attributeList = Object.entries(getWishlistItemAttributes());
    return /*#__PURE__*/ React.createElement("dl", null, attributeList.map(([key, value])=>value ? /*#__PURE__*/ React.createElement(React.Fragment, {
            key: key
        }, /*#__PURE__*/ React.createElement("dt", null, key), /*#__PURE__*/ React.createElement("dd", null, value)) : null
    ));
};

export { WishlistItemDescription };
//# sourceMappingURL=WishlistItemDescription.js.map
